import { useState } from "react";
import { AxiosRequest } from "_services/api";

export function useSalvarLote() {
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

  const [salvando, setSalvando] = useState(false);

  const salvar = async (idsProcessos: number[]) => {
    setSalvando(true);
    try {
      const { data } = await msAw.post("/financeiro/pagamento-taxa/lote", {
        idsProcessos,
      });
      return data;
    } finally {
      setSalvando(false);
    }
  };


  const atualizar = async (idLote: number, idsProcessos: number[]) => {
    setSalvando(true);
    try {
      const { data } = await msAw.put(
        `/financeiro/pagamento-taxa/lote/${idLote}/processos`,
        { idsProcessos },
      );
      return data;
    } finally {
      setSalvando(false);
    }
  };

  return { salvando, salvar, atualizar };
}
